import styles from './ProductItem.module.scss';

import cx from 'classnames';
import React, { FC, useRef } from 'react';

import { Card, ICardProps } from 'components/Card/Card';
import { ProductCaption } from 'components/CarouselModule/ProductItem/ProductCaption';
import { pauseEnhancedMedia, playEnhancedMedia } from 'components/CarouselModule/utils';
import { isEntry } from 'utils/EntryUtil';
import type { EnhancedMedia } from 'components/EnhancedMedia/EnhancedMedia';

export const ProductItem: FC<ICardProps> = ({ entry, tabIndex, className, ...props }) => {
  const enhancedMedia = useRef<EnhancedMedia>(null);

  if (!isEntry(entry)) return null;

  return (
    <div className={cx(styles.productItem, className)}>
      <Card
        className={styles.card}
        onMouseEnter={() => playEnhancedMedia(enhancedMedia.current)}
        onMouseLeave={() => pauseEnhancedMedia(enhancedMedia.current)}
        entry={entry}
        mediaClassName={styles.imageWrapper}
        captionClassName={styles.carouselCardCaption}
        enhancedMediaRef={enhancedMedia}
        mediaProps={{
          muted: true,
          autoPlay: false,
        }}
        {...props}
      >
        <ProductCaption entry={entry} tabIndex={tabIndex} />
      </Card>
    </div>
  );
};
